import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { parse, stringify } from '../../../utils/UrlUtil';


class AccountInvitationTableHeader extends Component {
  constructor(props) {
    super(props);

    // extract initial state from URL
    const { location } = this.props;
    const params = parse(location.search);

    // Make sure initial state has some nice defaults
    this.state = {
      filter: Object.assign(
        {
          query: '',
        },
        params.filter,
      ),
    };

    this.onQueryVariableChange = this.onQueryVariableChange.bind(this);
    this.onChangeQueryText = this.onChangeQueryText.bind(this);
    this.onStatusFilterChange = this.onStatusFilterChange.bind(this);
  }

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  onQueryVariableChange() {
    const { location, history } = this.props;
    const { filter } = this.state;

    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  }

  /**
   * Update the filter Query.
   */
  onChangeQueryText(event) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        query: event.currentTarget.value,
      },
    });
  }

  onStatusFilterChange(status) {
    const { filter } = this.state;

    const newState = {
      filter: {
        ...filter,
        status,
      },
    };

    this.setState(newState, () => this.onQueryVariableChange());
  }

  render() {
    const { filter } = this.state;
    return (
      <div className="p-grid">
        <div className="p-col-12">
          <div className="p-inputgroup">
            <InputText value={filter.query} onChange={this.onChangeQueryText} />
            <Button
              icon="pi pi-search"
              // For search we have a search button.
              // The state is already updated. We just upate the url
              onClick={this.onQueryVariableChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

AccountInvitationTableHeader.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withRouter(AccountInvitationTableHeader);
